import { render } from "./UserDeleteRequests.vue?vue&type=template&id=0e654c34"
import script from "./UserDeleteRequests.vue?vue&type=script&lang=js"
export * from "./UserDeleteRequests.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__